import { render, staticRenderFns } from "./bandingVideo.vue?vue&type=template&id=e0f3b5e4&scoped=true"
import script from "./bandingVideo.vue?vue&type=script&lang=js"
export * from "./bandingVideo.vue?vue&type=script&lang=js"
import style0 from "./bandingVideo.vue?vue&type=style&index=0&id=e0f3b5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f3b5e4",
  null
  
)

export default component.exports